const ORIGIN_TYPES = {
  STUDENT: 'STUDENT',
  STATE_WORKER: 'STATE_WORKER',
  RETIRED: 'RETIRED',
  HOUSEKEEPER: 'HOUSEKEEPER',
  UNEMPLOYED: 'UNEMPLOYED',
  AVAILABLE: 'AVAILABLE',
  AUTHORIZED_MINOR: 'AUTHORIZED_MINOR',
  SANCTIONED_NO_INTERNMENT: 'SANCTIONED_NO_INTERNMENT',
  NON_STATE_WORKER: 'NON_STATE_WORKER',
};

const ORIGIN_TYPES_ENUM = Object.keys(ORIGIN_TYPES);

export {
  ORIGIN_TYPES,
  ORIGIN_TYPES_ENUM,
};
